import React, { ReactNode } from "react";

interface NavigationLinkActionResult {
  action: (event: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => void;
  childrenOverwrite?: ReactNode;
}

const navigationLinkActions = (action: string): NavigationLinkActionResult => {
  switch (action) {
    default:
      return {
        action: (event) => {
          event.preventDefault();

          return false;
        },
        childrenOverwrite: undefined,
      };
  }
};

export default navigationLinkActions;
